/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Aside_Coach_BodyInputs */

const en_contact_aside_coach_body = /** @type {(inputs: Contact_Aside_Coach_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your coach runs their own page in the app. Write to them there; we only build the software.`)
};

const pl_contact_aside_coach_body = /** @type {(inputs: Contact_Aside_Coach_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twój trener ma w aplikacji własną stronę. Napisz do niego tam; my tylko tworzymy oprogramowanie.`)
};

/**
* | output |
* | --- |
* | "Your coach runs their own page in the app. Write to them there; we only build the software." |
*
* @param {Contact_Aside_Coach_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_aside_coach_body = /** @type {((inputs?: Contact_Aside_Coach_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Aside_Coach_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_aside_coach_body(inputs)
	return en_contact_aside_coach_body(inputs)
});